import React, { useState } from "react";
import { Button, ui } from "./ui";

// GitHub-style red-zone confirm: the destructive button only unlocks after the exact word is typed.
export default function RedZoneConfirm({ title, children, word, confirmLabel, busy, onCancel, onConfirm }) {
  const [typed, setTyped] = useState("");
  const ok = typed.trim().toLowerCase() === word.toLowerCase();
  return (
    <div role="dialog" aria-modal="true" onClick={onCancel} style={{ position: "fixed", inset: 0, zIndex: 1200, background: "rgba(0,0,0,.45)", display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: "min(440px,100%)", borderRadius: 10, border: "1px solid var(--border)", borderTop: "3px solid var(--danger)", background: "var(--card)", boxShadow: "var(--shadow-md)", color: "var(--text)", overflowWrap: "anywhere" }}>
        <div style={{ fontWeight: 650, fontSize: 15, color: "var(--danger)", padding: "14px 18px 0" }}>{title}</div>
        <div style={{ padding: "10px 18px 16px" }}>
          <div style={{ fontSize: 13, lineHeight: 1.5, marginBottom: 10 }}>{children} Type <b>{word}</b> to confirm.</div>
          <input autoFocus value={typed} onChange={(e) => setTyped(e.target.value)} aria-label={`Type ${word} to confirm`}
            style={{ ...ui.input, width: "100%", boxSizing: "border-box", fontFamily: "inherit", borderColor: ok ? "var(--danger)" : "var(--border)" }} />
        </div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", padding: "12px 18px", borderTop: "1px solid var(--border)", background: "var(--bg-card)", borderRadius: "0 0 10px 10px" }}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button variant="danger" disabled={!ok || busy} onClick={onConfirm}>
            {busy ? "Working…" : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
